// OTOMATIK KARISTIRMA EGRISI — tabletin birebir kopyasi.
// Kaynak: BeverageMachine src/components/utils/turkish_coffee_utils.js
// (autoMixerHwFromTemp, validateAutoMixerParams) ve AutoMixerDrawer.js.
// Tablette formul degisirse burasi da degismeli; sinirlar ve preset cihazdan
// (READ: setting.bounds / setting.preset) gelir, burada yalniz yedek var.

export const CURVE_KEYS = ["kneeTemp", "plateauHw", "stepHw", "stepDown", "floorHw"];

export const CURVE_LABELS = {
  kneeTemp: { label: "Dirsek Sıcaklığı", unit: "°C" },
  plateauHw: { label: "Plato Hızı", unit: "hw" },
  stepHw: { label: "Dirsek Hızı", unit: "hw" },
  stepDown: { label: "Basamak Düşüşü", unit: "hw" },
  floorHw: { label: "Taban Hızı", unit: "hw" },
};

export const FALLBACK_BOUNDS = {
  kneeTemp: [30, 70],
  plateauHw: [16, 61],
  stepHw: [16, 61],
  stepDown: [2, 8],
  floorHw: [14, 61],
};

export const FALLBACK_PRESET = {
  kneeTemp: 36,
  plateauHw: 45,
  stepHw: 35,
  stepDown: 2,
  floorHw: 18,
};

const FLOOR_MIN = 14;
const FLOOR_DEFAULT = 18;
const WINDOW = 5; // °C — aktif / cukur pencere genisligi

export const normalizeBounds = (bounds) => {
  const out = {};
  for (const k of CURVE_KEYS) {
    const b = bounds?.[k];
    out[k] =
      Array.isArray(b) && b.length === 2 && b.every(Number.isFinite)
        ? b
        : FALLBACK_BOUNDS[k];
  }
  return out;
};

// Alanin ust siniri — taban hizi dirsek hizini asamaz.
export const maxFor = (key, params, bounds) => {
  const [min, max] = bounds[key];
  if (key === "floorHw") return Math.max(min, Math.min(max, params?.stepHw ?? max));
  return max;
};

/**
 * Tabletteki validateAutoMixerParams ile ayni: gecerliyse null degil.
 * null deger = "varsayilan egri" ve GECERLIDIR (ayri kontrol edilir).
 */
export const validateCurve = (p, rawBounds) => {
  if (!p || typeof p !== "object" || Array.isArray(p)) return null;
  const bounds = normalizeBounds(rawBounds);
  const out = {};
  for (const k of CURVE_KEYS) {
    let v = p[k];
    if ((v === undefined || v === null) && k === "floorHw") v = FLOOR_DEFAULT;
    const [min, max] = bounds[k];
    if (typeof v !== "number" || !Number.isInteger(v) || v < min || v > max) {
      return null;
    }
    out[k] = v;
  }
  if (out.floorHw > out.stepHw) {
    if (p.floorHw === undefined || p.floorHw === null) {
      out.floorHw = Math.max(FLOOR_MIN, out.stepHw);
    } else {
      return null;
    }
  }
  return out;
};

/** Sicakliktan ham karistirici hizi (hw). ct <= 0 → null. */
export const hwFromTemp = (currentTemp, cookingTemperature, params) => {
  const { kneeTemp, plateauHw, stepHw, stepDown, floorHw } = params || {};
  const ct = Number(cookingTemperature) || 0;
  if (ct <= 0) return null;
  const t = Math.max(0, Math.min(ct, Number(currentTemp) || 0));
  const knee = Math.max(0, Math.min(ct, Number(kneeTemp) || 0));
  const plat = Number(plateauHw) || Number(stepHw) || FLOOR_DEFAULT;
  const step = Number(stepHw) || FLOOR_DEFAULT;
  const sd = Math.max(1, Number(stepDown) || 4);
  const floor = Math.max(FLOOR_MIN, Math.min(step, Number(floorHw) || FLOOR_DEFAULT));
  if (t <= knee) {
    if (knee <= 0) return Math.max(floor, Math.round(step));
    return Math.max(floor, Math.round(plat - (plat - step) * (t / knee)));
  }
  const elapsed = t - knee;
  const windowIdx = Math.floor(elapsed / WINDOW);
  if (windowIdx % 2 === 1) return floor;
  const activeN = windowIdx / 2;
  const start = step - sd * activeN;
  const pos = elapsed - windowIdx * WINDOW;
  return Math.round(Math.max(floor, start - sd * (pos / WINDOW)));
};

/** Grafik serisi — 0..ct arasi her 1 °C icin bir nokta. */
export const buildCurveSeries = (params, cookingTemperature) => {
  const ct = Math.round(Number(cookingTemperature) || 0);
  if (ct <= 0) return [];
  const out = [];
  for (let t = 0; t <= ct; t++) {
    out.push({ temp: t, hw: hwFromTemp(t, ct, params) });
  }
  return out;
};
